import styled from 'styled-components'
import { INTRO_ACCENT_COLOR } from '~/pages/anatomy/intro/libs/components/Anatomy/constants'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { Button } from '~/shared/components/Button'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

export const AnatomyStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${COLORS.GRAY_100};
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    max-width: ${BREAKPOINTS[375]}px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: safe center;
    flex: 1;
    padding: 24px 16px 150px;
    overflow: hidden;

    ${anatomyCompact} {
      padding: 24px 16px;
    }
  `,

  Title: styled.h1`
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 10px;

    span {
      color: ${INTRO_ACCENT_COLOR};
      font-weight: inherit;
    }

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f32};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh38};
    }
  `,

  Subtitle: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: ${COLORS.GRAY_700};
    margin-bottom: 24px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f15};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh20};
      margin-bottom: ${ANATOMY_COMPACT.spacing.s24};
    }
  `,

  Badges: styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-bottom: 50px;

    ${anatomyCompact} {
      margin-bottom: ${ANATOMY_COMPACT.spacing.s50};
    }
  `,

  Badge: styled.span`
    display: inline-flex;
    align-items: center;
    padding: 1px 5px;
    border-radius: 999px;
    background-color: #dad5ff;
    font-size: 13px;
    color: ${INTRO_ACCENT_COLOR};
    letter-spacing: -0.154px;
  `,

  Image: styled.img`
    flex: 1;
    max-height: min(360px, 45dvh);
    object-fit: contain;
    width: 100%;
  `,

  LoaderSection: styled.div`
    width: 100%;
    margin-top: 24px;

    ${anatomyCompact} {
      margin-top: ${ANATOMY_COMPACT.spacing.s24};
    }
  `,

  LoaderText: styled.p`
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 8px;
  `,

  ProgressWrapper: styled.div`
    width: 100%;
    height: 16px;
    border-radius: 14px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #d4c5ff;
  `,

  StyledButton: styled(Button)`
    width: 100%;
    margin-top: 32px;
  `,
}
